import { jsx } from "react/jsx-runtime";
import { cn } from "../lib/utils.js";
import { motion } from "framer-motion";
import { memo, useMemo } from "react";
const ShimmerComponent = ({
  children,
  as: Component = "p",
  className,
  duration = 2,
  spread = 2,
  style: styleProp,
  color,
  highlightColor
}) => {
  const MotionComponent = motion(
    Component
  );
  const dynamicSpread = useMemo(
    () => ((children == null ? void 0 : children.length) ?? 0) * spread,
    [children, spread]
  );
  const baseColor = color ?? "var(--color-muted-foreground)";
  const sweepColor = highlightColor ?? "var(--color-background)";
  return /* @__PURE__ */ jsx(
    MotionComponent,
    {
      animate: { backgroundPosition: "0% center" },
      className: cn(
        "tw:relative tw:inline-block tw:bg-[length:250%_100%,auto] tw:bg-clip-text tw:text-transparent",
        "tw:[background-repeat:no-repeat,padding-box]",
        className
      ),
      initial: { backgroundPosition: "100% center" },
      style: {
        "--spread": `${dynamicSpread}px`,
        backgroundImage: `linear-gradient(90deg, #0000 calc(50% - var(--spread)), ${sweepColor}, #0000 calc(50% + var(--spread))), linear-gradient(${baseColor}, ${baseColor})`,
        ...styleProp
      },
      transition: {
        repeat: Number.POSITIVE_INFINITY,
        duration,
        ease: "linear"
      },
      children
    }
  );
};
const Shimmer = memo(ShimmerComponent);
export {
  Shimmer
};
//# sourceMappingURL=shimmer.js.map
